import { render, staticRenderFns } from "./leaderboard.vue?vue&type=template&id=546f3dbf&scoped=true&"
import script from "./leaderboard.vue?vue&type=script&lang=js&"
export * from "./leaderboard.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard.vue?vue&type=style&index=0&id=546f3dbf&lang=scss&scoped=true&"
import style1 from "./leaderboard.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./leaderboard.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f3dbf",
  null
  
)

export default component.exports